import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorder} from "../../TheBorder";
import {gsap} from "gsap";

export class TheBorderXRipRunner implements SimplePresentation {

    constructor() {
    }

    public shouldRun(): boolean {
        return TheBorder.checkXRipEffect();
    }

    public start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => {
                controller.finish();
            }
        });
        tl.add(TheBorder.xRipButton.handleXRipWins());
    }
}